import { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "../../store";
import { GetBoatsForListingAPI } from "../../Admin/Redux/boats";
import { decryptByText } from "../bycrypt";
import { CapitalizeEachWordForName } from "../CustomFileUpoader";

const BoatContext = createContext(null);

export const BoatProvider = ({ children }) => {
  const dispatch = useAppDispatch();
  const [boats, setBoats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBoatsForProvider = async () => {
    try {
      const result = await dispatch(
        GetBoatsForListingAPI({
          populate: ["name", "org_name"],
        })
      );

      if (result?.success && result?.data?.data?.length > 0) {
        setBoats(
          result.data.data.map((boat) => ({
            ...boat,
            name: decryptByText(boat?.org_name || boat?.name),
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching boat data:", error);
    }
  };

  useEffect(() => {
    fetchBoatsForProvider();
  }, []);

  return (
    <BoatContext.Provider value={{ boats, loading, error, fetchBoatsForProvider }}>{children}</BoatContext.Provider>
  );
};

export const useBoats = () => useContext(BoatContext);
